gz-enum-filter {
  --dropdown-width: 400px;
}

.exclusion-list-form {
  padding: 0 calc(2 * var(--spacer));
  &--row {
    padding: 10px 0 var(--spacer) 0;
    display: inline-flex;
  }

  &--field {
    margin-right: calc(2 * var(--spacer));
    position: relative;
    height: calc(4 * var(--spacer));

    gz-enum-filter {
      width: 100%;
    }
  }
}
